import { FC } from 'react'

const MoreIcon: FC = () => (
  <svg
    viewBox="0 0 1024 1024"
    focusable="false"
    className=""
    data-icon="more"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
  >
    <title>More</title>
    <path d="M512 256c-70.4 0-128 57.6-128 128s57.6 128 128 128 128-57.6 128-128-57.6-128-128-128z m0 512c-70.4 0-128 57.6-128 128s57.6 128 128 128 128-57.6 128-128-57.6-128-128-128z m0-256c-70.4 0-128 57.6-128 128s57.6 128 128 128 128-57.6 128-128-57.6-128-128-128z" />
  </svg>
)

export default MoreIcon
